import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import { set as setSettings } from '../redux/settings'

export default function * requestChangeSettings (action) {
  const settings = action.payload

  const state = yield select()

  const id = state['view-myboard'].view.id
  const currentSettings = state['view-myboard'].settings

  const newSettings = {
    ...currentSettings,
    ...settings
  }

  const optimisticAction = yield optimisticPut(setSettings(newSettings))

  try {
    yield call(apiAction, 'ChangeVBoardSettings', {
      id,
      settings: newSettings
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    throw error
  }
}
